'use client';

import { logIn, type LogInProps } from '@shared/misc/next-auth/log-in';
import { GTM_EVENT_LOGIN } from '@shared/utils/constants/gtm';
import { GTM_EVENT_SEND_SUCCESS_LOGIN_KEY } from '@shared/utils/constants/session-storage-keys';
import { mapIntlLocaleToOptimizelyLocale } from '@shared/utils/helpers/map-intl-locale-to-optimizely-locale';
import { sendGtmEvent } from '@shared/utils/helpers/send-gtm-event';

export const loginHandler = async (props: LogInProps) => {
  sendGtmEvent({
    event: GTM_EVENT_LOGIN,
    eventName: GTM_EVENT_LOGIN,
    label: GTM_EVENT_LOGIN,
  });

  const relativeReturnUrl = props.options?.redirectTo || window.location.pathname;

  await logIn({
    ...props,
    authorizationParameters: {
      ...props.authorizationParameters,
      ui_locales: mapIntlLocaleToOptimizelyLocale(
        props.authorizationParameters.ui_locales
      ).toLowerCase(),
    },
    options: { redirectTo: relativeReturnUrl },
  }).then(() => window.sessionStorage.setItem(GTM_EVENT_SEND_SUCCESS_LOGIN_KEY, 'true'));
};
